import { MarkAsShippedArgs } from 'types/api/arguments/mark-as-shipped-args'

import { api } from './api'

export const markAsShipped = ({ transactionId, proofPhotoUuid }: MarkAsShippedArgs) =>
  api.put(`/transactions/${transactionId}/shipment/mark_as_shipped`, {
    proof_photo_uuid: proofPhotoUuid,
  })
